import React, { useEffect, useState } from "react";

import { toast } from "react-toastify";
import { en_translate_language_map } from "../../../constants/disclaimerTranslations";
import { subscribeAudio, playGlobalAudio, toggleGlobalAudio } from "../../../utils/audioManager"; import { playTTSProtected } from "../../../utils/ttsService";
const FaDownload = require("react-icons/fa").FaDownload;
const FaListAlt = require("react-icons/fa").FaListAlt;
const FaRegCopy = require("react-icons/fa").FaRegCopy;
const FaCaretDown = require("react-icons/fa").FaCaretDown;
const FaPause = require("react-icons/fa").FaPause;
const FaPlay = require("react-icons/fa").FaPlay;


interface MeetingSummaryProps {
  task_id: any
  title: string;
  htmlContent: string;
  rawContent: string;
  onExportPDF?: () => void;
  isOpen: boolean;
  onToggle: () => void;
}
export interface AudioState {
  id: string | null;
  isPlaying: boolean;
  isLoading: boolean;
}

const MeetingSummary: React.FC<MeetingSummaryProps> = ({
  task_id,
  title,
  htmlContent,
  rawContent,
  onExportPDF,
  isOpen,
  onToggle,
}) => {
  const ui_id = `${task_id}-${title}`;
  const [audioState, setAudioState] = useState<AudioState>({
    id: null,
    isPlaying: false,
    isLoading: false,
  });

useEffect(() => {
  const unsubscribe = subscribeAudio((id, playing) => {
    setAudioState((prev) => ({
      ...prev,
      id: id === ui_id ? id : prev.id,
      isPlaying: id === ui_id ? playing : false,
      isLoading: false,
    }));
  });

  return () => unsubscribe();
}, [ui_id]);

const getLanguageFromTitle = (title: string) => {
  const match = title.match(/\((.*?)\)/);
  return match ? match[1] : "English";
};


const handleCopy = (htmlString: string) => {
  const tempElement = document.createElement("div");
  tempElement.innerHTML = htmlString;
  const plainText = tempElement.textContent || tempElement.innerText || "";

  navigator?.clipboard
    ?.writeText(plainText)
    .then(() => toast.success("Copied to clipboard!"))
    .catch(() => toast.error("Failed to copy!"));
};

return (
  <div className="my-3">
    <div
      className="content-output-container for-summary mt-3"
      onClick={onToggle}
      style={{ cursor: "pointer" }}
    >

      <div className="content-output-text">
        <div className="first-final-icon">
          <FaListAlt />
        </div>
        <p className="first-final-text ">{title}</p>
      </div>
      <div className="icons-actions">
        <div
          className="translate-wrapper"
          onClick={(e) => e.stopPropagation()}>
          <div className="icon-with-label translate-icon-group">
            <FaDownload />
            <span className="icon-label">Export</span>
            <FaCaretDown className="down-arrow" />
          </div>
          <div className="translate-dropdown">
            <ul>
              <li onClick={onExportPDF}>Export as PDF</li>
            </ul>
          </div>
        </div>
        <div
          className="icon-with-label"
          onClick={(e) => {
            e.stopPropagation();
            handleCopy(htmlContent);
          }}
        >
          <FaRegCopy />
          <span className="icon-label">Copy</span>
        </div>

        <div className="text-center d-flex justify-content-center gap-3">

          <button
            className="tts-btn"
            disabled={audioState.isLoading && audioState.id === ui_id}
            onClick={(e) => {
              e.stopPropagation();
              playTTSProtected({
                text: rawContent,
                id: ui_id,     
                task_id: task_id, 
                lang: getLanguageFromTitle(title).toLowerCase(),
                languageMap: en_translate_language_map,
                audioState,
                setAudioState,
                toggleGlobalAudio,
                playGlobalAudio,
              });
            }}
          >
            {audioState.isLoading && audioState.id === ui_id ? (
              <span className="loader-audio"></span>
            ) : audioState.id === ui_id && audioState.isPlaying ? (
              <FaPause className="pause-audio" />
            ) : (
              <FaPlay className="play-audio" />
            )}
          </button>

        </div>
        <FaCaretDown
          style={{
            cursor: "pointer",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease",
          }}
        />
      </div>
    </div>

    {isOpen && (
      <div className="result-content bhashini-skip-translation">
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      </div>
    )}
  </div>
);
};

export default MeetingSummary;